import React, { useState, useEffect, useRef } from "react";
import {
  StatusTrans,
  inputFormat,
  moneyFormat,
  getOS,
  convetType,
  countDishes,
  StatusTransNoColor
} from "../../ultil";
import { modalStyle, modalStyleCenter, style } from "../../style";
const AnimationDetail = React.lazy(() =>
  import("../animation/AnimationDetail")
);
import Modal from "react-modal";
import moment from "moment";
import MenuItem from "./MenuItem";
import HeyUDownload from "./HeyUDownload";
import InputCustom from "../Input/InputCustom";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import {
  Avatar,
  AppBar,
  Box,
  Collapse,
  Divider,
  Paper,
  Tab,
  Tabs,
  Typography,
  IconButton,
  Grid,
  Button,
  ButtonBase,
  ButtonGroup,
  Toolbar,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio
} from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot
} from '@mui/lab';
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import StarRateIcon from '@mui/icons-material/StarRate';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

export default function DetailOrder({
  setIsCart,
  detailOrder,
  timeLine,
  comeBack,
  btnCancelOrder,
  platform,
  btnOrderHistory,
  configContact
}) {
  const [dataCarts, setdataCarts] = useState(_.cloneDeep(detailOrder.cart));
  const [isOpen, setIsOpen] = useState(false);
  const [openCollapse, setOpenCollapse] = useState(false);
  const anime = useRef(null);
  const BtnOpenQrcode = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const billTopping = dataDetail => {
    let sum = dataDetail.pricePromote;
    if (dataDetail.toppingSelected) {
      dataDetail.toppingSelected.map((item, i) => {
        item.topping.map((t, j) => {
          sum += t.price * t.quantity;
        });
      });
    }
    return sum * dataDetail.quantity;
  };

  const renderNameTopping = data => {
    let toppings = [];
    data.map((item, i) => {
      item.topping.map((t, j) => {
        toppings.push(t.name);
      });
    });
    return toppings.join(", ");
  };

  return (<>
    <Box sx={style}>
    <Box sx={{position: 'relative'}}>
      <AppBar
        position="sticky"
        color="inherit"
      >
        <Toolbar sx={{minHeight: '52px'}}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={comeBack}
            sx={{position: 'absolute'}}
          >
            <ArrowBackIcon fontSize="large"/>
          </IconButton>
          <TextTitle1 variant="h5" component="div" sx={{textAlign: 'center', flexGrow: '1'}}>
            #{detailOrder.code}
          </TextTitle1>

        </Toolbar>
      </AppBar>
      <Box px={2} py={1} display="flex" justifyContent="space-between">
        {StatusTrans(detailOrder.status, detailOrder.deliveryType)}
        {moment(detailOrder.updatedAt).format("DD/MM - HH:mm")}
      </Box>
      <Box px={2}>
        <React.Suspense fallback={<div />}>
          <AnimationDetail detailOrder={detailOrder} />
        </React.Suspense>
      </Box>
      {detailOrder.messageDelivery ? (
        <Box bgcolor = "#ffffff" p={2} my={1}>
          <TextBody>
            {detailOrder.messageDelivery}
          </TextBody>
        </Box>
      ) : null}
      <Box p={2} bgcolor="#ffffff">
        <TextBody mb={2}>Thông tin sản phẩm</TextBody>
        {dataCarts.length
          ? dataCarts.map((item, index) => {
          return (<MenuItem
            key={index}
            lastItem={index === (dataCarts.length - 1)}
            dataItem={item}
            quantity={item.quantity}
            readOnly
          />)})
          : null}
      </Box>
      <Box mt={2} p={2} bgcolor="#ffffff">
        <TextBody mb={2}><i className="icon-card"/> Thông tin thanh toán</TextBody>
        <Box sx={{display: 'flex'}} my={1}>
        <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Tổng tiền hàng</TextBody2>
        <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(detailOrder.money + (detailOrder.discountMoneyDeposit || 0))}</TextBody2>
        </Box>
        <Box sx={{display: 'flex'}} my={1}>
        <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Phí giao hàng</TextBody2>
        <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(detailOrder.salary + (_.get(detailOrder, 'orderType.resourceFee', 0) || 0))}</TextBody2>
        </Box>
        {
          _.get(detailOrder, 'salaryStrategy.tip', 0) ?
          <Box sx={{display: 'flex'}} my={1}>
          <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Hỗ trợ tài xế</TextBody2>
          <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(_.get(detailOrder, 'salaryStrategy.tip', 0))}</TextBody2>
          </Box>
          :null
        }

        {
          _.get(detailOrder, 'discountMoney', 0) || _.get(detailOrder, 'discountMoneyDeposit', 0)?
          <Box sx={{display: 'flex'}} my={1}>
          <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Khuyến mãi</TextBody2>
          <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}>{moneyFormat(_.get(detailOrder, 'discountMoney', 0) + (_.get(detailOrder, 'discountMoneyDeposit', 0) || 0))}</TextBody2>
          </Box>
          :null
        }

        <Box sx={{display: 'flex'}} my={1}>
        <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}><strong>Tổng thanh toán</strong></TextBody2>
        <TextBody2 sx={{minWidth: '82px', textAlign: 'right'}}><strong>{moneyFormat(
          (detailOrder.money || 0) +
          (detailOrder.salaryStrategy.tip || 0) +
          (detailOrder.orderType.resourceFee || 0) +
          (detailOrder.salary || 0) -
          (detailOrder.discountMoney || 0)
        )}</strong></TextBody2>
        </Box>
      </Box>
      {
        !_.isEmpty(detailOrder.delivery) ?
        <Box mt={2} p={2} bgcolor="#ffffff">
          <Box sx={{display: 'flex'}}>
            <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}>Mã giao vận: {detailOrder.delivery.code}</TextBody2>
            <TextBody2 className="line-clamp-1" component="a" target="_blank"
            href={detailOrder.delivery.linkOrder}
            >Xem chi tiết đơn <i className="icon-arrow-right-2"/></TextBody2>
          </Box>
          {
            !_.isEmpty(detailOrder.delivery.shipper) ?
            <Box mt={2}>
              <TextBody mb={2}>Thông tin tài xế</TextBody>
              <CardInfo
                avatar={_.get(detailOrder, 'delivery.shipper.facebook.picture')}
                name={_.get(detailOrder, 'delivery.shipper.facebook.name')}
                phone={_.get(detailOrder, 'delivery.shipper.phone')}
                others={<span>{_.get(detailOrder, 'delivery.shipper.ship.rateStar')}<StarRateIcon sx={{color: "#fcba03", mb: '-2px'}}/>
                /{_.get(detailOrder, 'delivery.shipper.ship.totalRides')} chuyến</span>}
                onCall={()=>window.open(`tel:${_.get(detailOrder, 'delivery.shipper.phone')}`)}
                onMessage={()=>window.open(`sms:${_.get(detailOrder, 'delivery.shipper.phone')}`)}
                showCall={platform}
                showMessage={platform}
              />
            </Box>
            :null
          }
        </Box>
        :null
      }

      <Box mt={2} p={2} bgcolor="#ffffff">
        <TextBody mb={2}>Thông tin cửa hàng</TextBody>
        <CardInfo
          avatar={_.get(detailOrder, 'store.image')}
          name={_.get(detailOrder, 'store.name')}
          others={<span>Địa chỉ: {_.get(detailOrder, 'store.address')}</span>}
          onCall={()=>window.open(`tel:${_.get(detailOrder, 'store.phone')}`)}
          onMessage={()=>window.open(`sms:${_.get(detailOrder, 'store.phone')}`)}
          showCall={platform && configContact.isOpenCall}
          showCall={platform && configContact.isOpenMessage}
        />
      </Box>
      <Box mt={2} p={2} bgcolor="#ffffff">
        <Box display='flex' alignItems="center">
          <Box flexGrow={1}>
            <TextBody><i className="icon-document-text"/> Thông tin đơn hàng</TextBody>
            <TextBody2 mt={1}>Mã đơn: {_.get(detailOrder, 'code')}</TextBody2>
          </Box>
          <Box>
            <TextBody2 onClick={()=>setOpenCollapse(openCollapse ? false : true)} color="#929394" sx={{cursor:"pointer"}}>{openCollapse ? <span>Ẩn bớt <ExpandLess/></span> : <span>Xem thêm <ExpandMore/></span>}</TextBody2>
          </Box>
        </Box>
        <Collapse in={openCollapse} timeout="auto" unmountOnExit>
        <Timeline mt={2} sx={{[`& .${timelineOppositeContentClasses.root}`]: { flex: 0.2 } }}>
          {
            !_.isEmpty(timeLine) ?
            timeLine.map((item, i)=><TimelineItem key={i} sx={(timeLine.length-1) === i ? {minHeight: '0px'} : {minHeight: '50px'}}>
              <TimelineOppositeContent color="textSecondary">
                <TextBody2 sx={{textAlign: 'right'}}>{moment(item.createdAt).format("HH:mm")}</TextBody2>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector sx={{color: i ? "#1976d2" : "transparent", bgcolor: i ? "#1976d2" : "transparent", height: '11.5px', flexGrow: 0}}/>
                <TimelineDot color="primary" sx={{margin: '0px'}}/>
                {(timeLine.length-1) !== i && <TimelineConnector sx={{color: "#1976d2", bgcolor: "#1976d2"}}/>}
              </TimelineSeparator>
              <TimelineContent><TextBody2>{convetType(item)}</TextBody2></TimelineContent>
            </TimelineItem>)
            :null
          }
        </Timeline>
        </Collapse>
      </Box>

      <Box mt={2} p={2} bgcolor="#ffffff">
        <TextBody mb={2}>Thông tin người mua</TextBody>
        <CardInfo
          avatar={"https://media.heyu.asia/uploads/new-img-service/2021-10-07-iconBuyer.png"}
          name={_.get(detailOrder, 'receiver.name')}
          name={_.get(detailOrder, 'receiver.phone', '').slice(0, -4) + "****"}
          others={<span>Địa chỉ: {_.get(detailOrder, 'receiver.address.name')}</span>}
        />
      </Box>
      <HeyUDownload platform={platform}/>
      <Box px={2} mt={2}>
        <ButtonBase component="a" href="tel:1900633689" variant="contained" sx={{fontSize: '14px', width: '100%', textTransform: 'none', bgcolor: '#ffffff', color: '#1589D8', borderRadius: '8px', padding: '6px 16px'}}>
          Liên hệ trợ giúp
        </ButtonBase>
      </Box>

      <Box p={2}>
        {
          [0].includes(_.get(detailOrder, 'status'))?
          <ButtonBase onClick={(e)=>{
            btnCancelOrder(_.get(detailOrder, '_id'))
          }} variant="contained" sx={{fontSize: '14px', width: '100%', textTransform: 'none', bgcolor: '#e93940', color: '#ffffff', borderRadius: '8px', padding: '6px 16px'}}>
            Hủy đơn
          </ButtonBase>
          :
          <ButtonBase onClick={(e)=>{
            btnOrderHistory(detailOrder)
          }} variant="contained" sx={{fontSize: '14px', width: '100%', textTransform: 'none', bgcolor: '#ffffff', borderRadius: '8px', padding: '6px 16px'}}>
            Đặt lại đơn
          </ButtonBase>
        }
        
      </Box>
    </Box>
    </Box>
  </>);
}

const CardInfo = ({avatar, name, phone, others, showCall = false, onCall, showMessage = false, onMessage})=>{
  return <Box>
    <Box display="flex">
      <Box>
        <Avatar
          sx={{ width: '70px', height: '70px', borderRadius: '16px'}}
          alt="Shipper Avatar"
          src={avatar}
          />
      </Box>
      <Box flexGrow={1} px={2} display="flex" flexDirection="column" justifyContent="space-around">
        {name ? <TextBody2>{name}</TextBody2> : null}
        {phone ? <TextBody2>{phone}</TextBody2> : null}
        {others ? <TextBody2>{others}</TextBody2> : null}
      </Box>
    </Box>
    {
      showCall || showMessage ?
      <Box fullwidth="true" mt={2}>
      <ButtonGroup fullWidth size="large" aria-label="large button group">
      {showCall ? <Button onClick={onCall}>Gọi</Button> : null}
      {showMessage ? <Button onClick={onMessage}>Nhắn tin</Button> : null}
      </ButtonGroup>
      </Box>
      :null
    }
  </Box>;
}
